var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"work"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"caption"},[_vm._v(" ERROR ")]),_c('div',{staticClass:"subcaption"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Something wrong. Please, contact our support team. ")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }